import React from "react";
import { Box, Typography } from "@mui/material";

const cardSx = {
  display: "grid",
  overflow: "hidden",
  border: "1px solid var(--sub-border, #dfe6ed)",
  borderRadius: "10px",
  backgroundColor: "#fff",
  boxShadow: "0 8px 20px rgba(15, 23, 42, .05)",
};

const topSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.5,
  minHeight: 44,
  p: "8px 9px",
  backgroundColor: "#fff",
};

const titleSx = {
  display: "flex",
  alignItems: "center",
  minWidth: 0,
  gap: 1.25,
};

const iconSx = {
  flex: "0 0 auto",
  display: "grid",
  placeItems: "center",
  width: 38,
  height: 38,
  borderRadius: "50%",
  backgroundColor: "var(--sub-primary-soft, #eaf3fb)",
  color: "var(--sub-primary, #0b5cab)",
  "& svg": {
    fontSize: 20,
  },
};

const labelSx = {
  color: "#1f2937",
  fontSize: "13px !important",
  fontWeight: "700 !important",
  lineHeight: "1.25 !important",
};

const valueSx = {
  flex: "0 0 auto",
  pr: 1.5,
  color: "#111827",
  fontSize: "26px !important",
  fontWeight: "750 !important",
  lineHeight: "1 !important",
};

const rowsSx = {
  display: "grid",
  gridTemplateColumns: "repeat(var(--app-stat-row-count, 2), minmax(0, 1fr))",
  gap: 0,
  borderTop: "1px solid #e5e7eb",
  backgroundColor: "#f8fafc",
};

const rowSx = {
  display: "grid",
  alignContent: "center",
  minHeight: 38,
  px: 1.75,
  py: 1.25,
  "& + &": {
    borderLeft: "1px solid #e5e7eb",
  },
};

const rowLabelSx = {
  color: "var(--sub-muted, #667085)",
  fontSize: "11px !important",
  fontWeight: "650 !important",
  lineHeight: "1.2 !important",
};

const rowValueSx = {
  display: "block",
  minWidth: 0,
  mt: 0.5,
  overflowWrap: "anywhere",
  fontSize: "14px !important",
  fontWeight: "800 !important",
  lineHeight: "1.25 !important",
  color: "#2563eb",
};

const normalizeRow = (row) =>
  typeof row === "object" ? row : { value: row };

export default function AppStatCard({
  label,
  value,
  icon,
  rows = [],
  children,
  iconSx: iconSxProp,
  valueSx: valueSxProp,
  sx,
}) {
  const normalizedRows = rows.map(normalizeRow);
  const rowCount = Math.max(normalizedRows.length, 1);

  return (
    <Box sx={{ ...cardSx, ...sx }}>
      <Box sx={topSx}>
        <Box sx={titleSx}>
          {icon && <Box component="span" sx={{ ...iconSx, ...iconSxProp }}>{icon}</Box>}
          <Typography sx={labelSx}>{label}</Typography>
        </Box>
        <Typography sx={{ ...valueSx, ...valueSxProp }}>{value}</Typography>
      </Box>

      {(normalizedRows.length > 0 || children) && (
        <Box sx={{ ...rowsSx, "--app-stat-row-count": rowCount }}>
          {children || normalizedRows.map((row, index) => (
            <Box key={row.key ?? row.label ?? index} sx={rowSx}>
              {row.label && <Typography component="span" sx={rowLabelSx}>{row.label}</Typography>}
              <Typography component="strong" sx={{ ...rowValueSx, color: row.color || rowValueSx.color }}>
                {row.value}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
